function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("g", {
  fontWeight: "400",
  fontFamily: "sans-serif",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 0C10.78 0 0 10.78 0 24s10.78 24 24 24 24-10.78 24-24S37.22 0 24 0zm0 6c9.98 0 18 8.02 18 18s-8.02 18-18 18S6 33.98 6 24 14.02 6 24 6z",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  },
  overflow: "visible"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 7l-4.24 4.25 2.12 2.12 27.04 27.04 2.12 2.12 4.24-4.24-2.12-2.12L13.37 9.13z",
  style: {
    lineHeight: "normal",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: "0",
    textAlign: "start",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    textTransform: "none",
    textOrientation: "mixed",
    shapePadding: "0",
    isolation: "auto",
    mixBlendMode: "normal"
  },
  overflow: "visible"
}))));